import * as CC from '@chakra-ui/react'
import * as HeroIcons from '@heroicons/react/solid'
import classNames from 'classnames'
import Image from 'next/image'
import React from 'react'
import { mapStore } from '../../state/mapStore'
import { guidGenerator } from '../../utils/functions'
import DistanceDurationWidget from './DistanceDurationWidget'
import Step from './Step'
import endMarkerImage from '../../../../../public/assets/EndMarker@4x.png'

interface ITurnByTurnDirections {
    customClasses?: string
}

const TurnByTurnDirections: React.FC<ITurnByTurnDirections> = ({ customClasses }) => {
    const directionCoordinates = mapStore((state) => state.directionCoordinates)
    const directionLegs = mapStore((state) => state.directionLegs)

    const parsedDirectionLegs = directionLegs.map((leg) => ({
        ...leg,
        id: guidGenerator(),
    }))
    return (
        <div className={customClasses}>
            <div className='mb-4'>
                <DistanceDurationWidget />
            </div>
            <CC.Accordion defaultIndex={[0]} allowMultiple bgColor={'white'}>
                {parsedDirectionLegs?.map((leg, index) => {
                    const moreAccordions = leg?.steps?.length > 3
                    const beginningStepsArr = moreAccordions ? leg?.steps?.slice(0, 2) : null
                    const finalStepArr = moreAccordions ? leg?.steps?.slice(-1) : null
                    const additionalSteps = moreAccordions ? leg?.steps?.slice(2, -1) : null
                    const isLastLeg = index === parsedDirectionLegs.length - 1
                    return (
                        <React.Fragment key={`${leg?.id}-${guidGenerator()}`}>
                            <CC.AccordionItem
                                key={leg.id}
                                borderColor={'gray.100'}
                                className={index === 0 ? 'border-t-0 pb-4' : 'py-4'}
                            >
                                {({ isExpanded }) => (
                                    <>
                                        <CC.AccordionButton px={0}>
                                            <CC.Icon
                                                as={HeroIcons.ChevronRightIcon}
                                                className={classNames(
                                                    isExpanded ? 'rotate-90' : 'rotate-0',
                                                    'transition-all duration-100'
                                                )}
                                            />

                                            <div className='space-y-1 pl-3 text-sm md:mt-auto'>
                                                <p className='flex justify-start text-left font-bold'>
                                                    {directionCoordinates[index]?.title}
                                                </p>
                                                {directionCoordinates[index]?.address !==
                                                directionCoordinates[index]?.title ? (
                                                    <p className='flex justify-start text-left text-xs text-gray-300'>
                                                        {directionCoordinates[index]?.placeName}
                                                    </p>
                                                ) : null}
                                            </div>
                                        </CC.AccordionButton>
                                        <CC.AccordionPanel px={0} pb={0}>
                                            <div
                                                className={` mb-3 flex w-full bg-white md:mb-4 id-${leg.id}`}
                                            >
                                                <div className='leg-group flex h-full w-full flex-col bg-white'>
                                                    {beginningStepsArr?.map((step) => {
                                                        const parsedStep = {
                                                            ...step,
                                                            id: guidGenerator(),
                                                        }
                                                        return (
                                                            <div
                                                                key={parsedStep?.id}
                                                                className='my-4'
                                                            >
                                                                <Step
                                                                    id={parsedStep?.id}
                                                                    step={step}
                                                                />
                                                            </div>
                                                        )
                                                    })}
                                                    <CC.Accordion allowMultiple>
                                                        <CC.AccordionItem
                                                            border='none'
                                                            borderWidth={0}
                                                        >
                                                            {({ isExpanded }) => (
                                                                <>
                                                                    <CC.AccordionButton px={0}>
                                                                        <CC.Icon
                                                                            as={
                                                                                HeroIcons.ChevronRightIcon
                                                                            }
                                                                            className={classNames(
                                                                                isExpanded
                                                                                    ? 'rotate-90'
                                                                                    : 'rotate-0',
                                                                                'text-info transition-all duration-100'
                                                                            )}
                                                                        />
                                                                        <p className='ml-3 text-sm text-info'>
                                                                            {`${additionalSteps?.length} more steps`}
                                                                        </p>
                                                                    </CC.AccordionButton>
                                                                    <CC.AccordionPanel
                                                                        pl={0}
                                                                        pb={0}
                                                                    >
                                                                        <div className='mt-2'>
                                                                            {additionalSteps?.map(
                                                                                (step, index) => {
                                                                                    const parsedStep =
                                                                                        {
                                                                                            ...step,
                                                                                            id: guidGenerator(),
                                                                                        }
                                                                                    return (
                                                                                        <div
                                                                                            key={
                                                                                                parsedStep?.id
                                                                                            }
                                                                                            className={
                                                                                                index !==
                                                                                                additionalSteps?.length -
                                                                                                    1
                                                                                                    ? 'mb-6'
                                                                                                    : ''
                                                                                            }
                                                                                        >
                                                                                            <Step
                                                                                                id={
                                                                                                    parsedStep?.id
                                                                                                }
                                                                                                step={
                                                                                                    step
                                                                                                }
                                                                                            />
                                                                                        </div>
                                                                                    )
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    </CC.AccordionPanel>
                                                                </>
                                                            )}
                                                        </CC.AccordionItem>
                                                    </CC.Accordion>
                                                    {finalStepArr?.map((step) => {
                                                        const parsedStep = {
                                                            ...step,
                                                            id: guidGenerator(),
                                                        }
                                                        return (
                                                            <div
                                                                className='mt-5'
                                                                key={parsedStep?.id}
                                                            >
                                                                <Step
                                                                    id={parsedStep?.id}
                                                                    step={step}
                                                                />
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </CC.AccordionPanel>
                                    </>
                                )}
                            </CC.AccordionItem>
                            {isLastLeg && (
                                <div className='my-2 flex'>
                                    <div className='relative right-2 max-h-10 min-h-10 min-w-[2.25rem] max-w-[2.25rem]'>
                                        <Image
                                            src={endMarkerImage}
                                            alt='Black and white finish marker'
                                            layout='fill'
                                        />
                                    </div>
                                    <div className='text-sm'>
                                        <p className='font-bold'>
                                            {directionCoordinates[index + 1]?.title}
                                        </p>
                                        {directionCoordinates[index + 1]?.address !==
                                        directionCoordinates[index + 1]?.title ? (
                                            <p className='text-xs text-gray-300'>
                                                {directionCoordinates[index + 1]?.placeName}
                                            </p>
                                        ) : null}
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
                    )
                })}
            </CC.Accordion>
        </div>
    )
}
export default TurnByTurnDirections
